import Vue from "vue";
import Vuex from "vuex";
import { LayoutState } from "./layout";
import { UserState } from "./user";
import { LineItemState } from "./lineItem";
import { CampaignState } from "./campaign";
import { AvalabilityState } from "./availability";
import { ReportState } from "./report";
import { DashboardState } from "./dashboard";

Vue.use(Vuex);

export interface RootState {
  layout: LayoutState;
  user: UserState;
  campaign: CampaignState;
  lineItem: LineItemState;
  availability: AvalabilityState;
  report: ReportState;
  dashboard: DashboardState;
}

export default new Vuex.Store<RootState>({});
